const SLOT_COUNT = 7;
const SLOT_NICKNAMES = ["Kick", "Snare", "Metal", "Clap", "Can", "Tom", "Nut"];
const PAGES = 56;
const PAGE_SIZE = 1024;
const PAGES_TO_SEND = PAGES / 2;
const TOTAL_BUFFER = PAGES * PAGE_SIZE;
const HALF_BUFFER = TOTAL_BUFFER / 2;
const TRANSFER_BYTES = PAGES_TO_SEND * PAGE_SIZE;
const MARKER_BYTES = SLOT_COUNT * 4;
const START_COMMAND = 82;
const PATTERN_SEND_COMMAND = 80;
const PATTERN_CUE_COMMAND = 81;
const PATTERN_SAVE_COMMAND = 83;
const PATTERN_CHAIN_COMMAND = 84;
const SETTINGS_COMMAND = 85;
const PATTERN_REQUEST_COMMAND = 112;
const PATTERN_CHAIN_REQUEST_COMMAND = 113;
const SETTINGS_REQUEST_COMMAND = 114;
const PATTERN_VERSION = 1;
const PATTERN_COUNT = 16;
const PATTERN_STEP_COUNT = 16;
const PATTERN_VOICE_COUNT = 8;
const PATTERN_CURRENT_SLOT = 255;
const PATTERN_VOICE_LABELS = ["Kick", "Snare", "Metal", "Clap", "Can", "Tom", "Nut", "Synth"];
const PATTERN_MAGIC = [68, 56, 80, 84];
const PATTERN_FRAME_BYTES = PATTERN_MAGIC.length + 4 + PATTERN_STEP_COUNT + 1;
const PATTERN_STEP_MAGIC = [68, 56, 83, 84];
const PATTERN_STEP_FRAME_BYTES = PATTERN_STEP_MAGIC.length + 4;
const SONG_CHAIN_MAGIC = [68, 56, 67, 72];
const SONG_CHAIN_SLOT_COUNT = 16;
const SONG_CHAIN_FRAME_BYTES = SONG_CHAIN_MAGIC.length + 2 + SONG_CHAIN_SLOT_COUNT + 1;
const SETTINGS_MAGIC = [68, 56, 83, 69];
const SETTINGS_FRAME_BYTES = SETTINGS_MAGIC.length + 4 + 1;
const CLOCK_RESOLUTION_NORMAL = 0;
const CLOCK_RESOLUTION_STEP = 1;
const DEFAULT_MIDI_CHANNEL = 10;
const SERIAL_FRAME_TYPES = [
  { type: "pattern", magic: PATTERN_MAGIC, length: PATTERN_FRAME_BYTES },
  { type: "step", magic: PATTERN_STEP_MAGIC, length: PATTERN_STEP_FRAME_BYTES },
  { type: "song", magic: SONG_CHAIN_MAGIC, length: SONG_CHAIN_FRAME_BYTES },
  { type: "settings", magic: SETTINGS_MAGIC, length: SETTINGS_FRAME_BYTES },
];
const PATTERN_AUTO_SEND_DELAY_MS = 80;
const DEFAULT_SAMPLE_RATE = 22050;
const DETON8_USB_VENDOR_ID = 0x16d0;
const DETON8_USB_PRODUCT_ID = 0x0e6f;
const DETON8_SERIAL_FILTERS = [
  { usbVendorId: DETON8_USB_VENDOR_ID, usbProductId: DETON8_USB_PRODUCT_ID },
];
const DETON8_SERIAL_BAUD_RATE = 2000000;
const SERIAL_RECONNECT_INITIAL_DELAY_MS = 700;
const SERIAL_RECONNECT_MAX_DELAY_MS = 5000;
const LEGACY_MIDI_VENDOR_ID = 0x7d;
const LEGACY_MIDI_MAGIC = [68, 56];
const LEGACY_MIDI_VERSION = 1;
const LEGACY_MIDI_START_COMMAND = 83;
const LEGACY_MIDI_DATA_COMMAND = 68;
const LEGACY_MIDI_MARKERS_COMMAND = 77;
const LEGACY_MIDI_CHUNK_BYTES = 64;
const LEGACY_MIDI_CHUNKS_PER_PAGE = PAGE_SIZE / LEGACY_MIDI_CHUNK_BYTES;
const LEGACY_MIDI_CHUNK_DELAY_MS = 34;
const LEGACY_MIDI_PAGE_DELAY_MS = 80;
const SUPPORTED_AUDIO = new Set(["wav", "wave", "mp3", "aif", "aiff"]);
const AUDIO_FILE_ACCEPT = ".wav,.wave,.mp3,.aif,.aiff,.WAV,.WAVE,.MP3,.AIF,.AIFF";
const KIT_FILE_ACCEPT = `${AUDIO_FILE_ACCEPT},.d8,.D8`;

const connectBtn = document.getElementById("connect-btn");
const manualConnectBtn = document.getElementById("manual-connect-btn");
const uploadBtn = document.getElementById("upload-btn");
const dropZone = document.getElementById("drop-zone");
const browseBtn = document.getElementById("browse-btn");
const fileInput = document.getElementById("file-input");
const slotsContainer = document.getElementById("slots-container");
const slotCountEl = document.getElementById("slot-count");
const transferStatusEl = document.getElementById("transfer-status");
const transferProgressBar = document.getElementById("transfer-progress-bar");
const kitSelect = document.getElementById("kit-select");
const saveKitBtn = document.getElementById("save-kit-btn");
const legacyMidiContainer = document.querySelector(".legacy-midi");
const legacyMidiToggleBtn = document.getElementById("legacy-midi-toggle-btn");
const legacyMidiPanel = document.getElementById("legacy-midi-panel");
const legacyMidiOutputSelect = document.getElementById("legacy-midi-output-select");
const legacyMidiSendBtn = document.getElementById("legacy-midi-send-btn");
const patternGrid = document.getElementById("pattern-grid");
const patternSlotSelect = document.getElementById("pattern-slot-select");
const clearPatternBtn = document.getElementById("clear-pattern-btn");
const randomPatternBtn = document.getElementById("random-pattern-btn");
const copyPatternBtn = document.getElementById("copy-pattern-btn");
const pastePatternBtn = document.getElementById("paste-pattern-btn");
const savePatternBtn = document.getElementById("save-pattern-btn");
const songLengthSelect = document.getElementById("song-length-select");
const songBuilder = document.getElementById("song-builder");
const settingsSectionButtons = Array.from(document.querySelectorAll("[data-settings-section]"));
const settingsPages = Array.from(document.querySelectorAll("[data-settings-page]"));
const analogClockSelect = document.getElementById("analog-clock-select");
const midiClockSelect = document.getElementById("midi-clock-select");
const midiChannelSelect = document.getElementById("midi-channel-select");
const tabButtons = Array.from(document.querySelectorAll("[data-tab]"));
const tabPanels = Array.from(document.querySelectorAll("[data-panel]"));

const state = {
  samples: Array.from({ length: SLOT_COUNT }, () => null),
  audioBuffer: new Uint8Array(TOTAL_BUFFER + 1),
  markersIn: new Uint16Array(SLOT_COUNT),
  markersOut: new Uint16Array(SLOT_COUNT),
  lastLength: 0,
  port: null,
  portOpening: false,
  reconnectPending: false,
  uploading: false,
  patternTransfer: false,
  activeTab: "kit",
  pattern: {
    slot: 0,
    patterns: Array.from({ length: PATTERN_COUNT }, () => new Uint8Array(PATTERN_STEP_COUNT)),
    steps: null,
    clipboard: null,
    clipboardSlot: null,
  },
  song: {
    length: 1,
    slots: new Uint8Array(SONG_CHAIN_SLOT_COUNT),
    dirty: false,
    loaded: false,
  },
  settings: {
    activeSection: "clock",
    analogClockResolution: CLOCK_RESOLUTION_NORMAL,
    midiClockResolution: CLOCK_RESOLUTION_NORMAL,
    midiChannel: DEFAULT_MIDI_CHANNEL,
    loaded: false,
  },
  legacyMidi: {
    access: null,
    expanded: false,
    opening: false,
    outputs: [],
    outputId: "",
    sending: false,
  },
};

state.pattern.steps = state.pattern.patterns[0];
state.audioBuffer.fill(127);

const slotUI = [];
const patternUI = Array.from({ length: PATTERN_VOICE_COUNT }, () => new Array(PATTERN_STEP_COUNT));
const songSlotSelects = [];
const patternPaint = {
  active: false,
  mode: null,
  pointerId: null,
  lastKey: null,
};
let currentSlotForFile = null;
let audioCtx;
let waveformResizeTimer = null;
let serialReader = null;
let serialReaderPromise = null;
let serialReadStopRequested = false;
let serialReconnectTimer = null;
let patternAutoSendTimer = null;
let patternAutoSendQueued = false;
let songAutoSendTimer = null;
let songAutoSendQueued = false;
let copyPatternFeedbackTimer = null;
let applyingRemotePattern = false;
const patternLocalEditAt = new Array(PATTERN_COUNT).fill(0);
const patternRefreshStartedAt = new Array(PATTERN_COUNT).fill(0);
let songLocalEditAt = 0;
let songRefreshStartedAt = 0;
let settingsLocalEditAt = 0;
let settingsRefreshStartedAt = 0;
const serialPatternBuffer = [];
const deviceStepFlashTimers = new Array(PATTERN_STEP_COUNT).fill(null);

init();

function init() {
  initTabs();
  initPatternEditor();
  initSongBuilder();
  initSlots();
  renderSettingsEditor();
  registerEventListeners();
  registerGlobalDragGuards();
  updateSlotCount();
  renderPatternEditor();
  setTransferProgress(0);
  updateControls();
  if (location.protocol === "file:") {
    log("Running from file://. Start a local server (e.g. `python3 -m http.server`) so WebSerial and file pickers work correctly.", "warn");
  }
  if (!window.isSecureContext) {
    log("Secure context is required for WebSerial. Use https:// or http://localhost.", "warn");
  }
  if (!("serial" in navigator)) {
    log("This browser build does not expose navigator.serial. Update Chrome/Edge or enable the WebSerial flag.", "warn");
  }
  log("Ready. Drop audio files, load a .d8 kit, or edit a pattern to get started.");

  if (canUseWebSerial()) {
    navigator.serial.addEventListener("connect", handleSerialConnect);
    navigator.serial.addEventListener("disconnect", handleSerialDisconnect);
    void autoConnectToKnownSerialPort();
  } else {
    log("WebSerial is not active in this context. Use Chrome/Edge over https:// or http://localhost.", "error");
  }

  window.addEventListener("resize", () => {
    if (waveformResizeTimer) {
      clearTimeout(waveformResizeTimer);
    }
    waveformResizeTimer = setTimeout(() => {
      redrawAllWaveforms();
    }, 120);
  });
}

function initTabs() {
  if (!tabButtons.length || !tabPanels.length) {
    return;
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setActiveTab(button.dataset.tab || "kit");
    });
  });
  setActiveTab(state.activeTab);
}

function setActiveTab(tabName) {
  const nextTab = ["kit", "pattern", "settings"].includes(tabName) ? tabName : "kit";
  state.activeTab = nextTab;

  tabButtons.forEach((button) => {
    const active = button.dataset.tab === nextTab;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-selected", active ? "true" : "false");
    button.tabIndex = active ? 0 : -1;
  });

  tabPanels.forEach((panel) => {
    const active = panel.dataset.panel === nextTab;
    panel.hidden = !active;
    panel.classList.toggle("tab-panel--active", active);
  });

  if (nextTab === "kit") {
    requestAnimationFrame(redrawAllWaveforms);
  } else if (nextTab === "settings") {
    renderSettingsEditor();
  }
}

function initPatternEditor() {
  if (!patternGrid) {
    return;
  }

  patternGrid.innerHTML = "";
  patternGrid.style.setProperty("--pattern-steps", String(PATTERN_STEP_COUNT));

  const rulerLabel = document.createElement("div");
  rulerLabel.className = "pattern-ruler-label";
  rulerLabel.textContent = "Step";
  patternGrid.appendChild(rulerLabel);

  for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
    const stepNumber = document.createElement("div");
    stepNumber.className = "pattern-step-number";
    if (step % 8 === 0) {
      stepNumber.classList.add("step-marker-8");
    } else if (step % 4 === 0) {
      stepNumber.classList.add("step-marker-4");
    }
    stepNumber.textContent = String(step + 1).padStart(2, "0");
    patternGrid.appendChild(stepNumber);
  }

  for (let voice = 0; voice < PATTERN_VOICE_COUNT; voice++) {
    const label = document.createElement("div");
    label.className = "pattern-label";
    label.textContent = PATTERN_VOICE_LABELS[voice] || `Voice ${voice + 1}`;
    patternGrid.appendChild(label);

    for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
      const cell = document.createElement("button");
      cell.className = "pattern-cell";
      if (step % 8 === 0) {
        cell.classList.add("step-marker-8");
      } else if (step % 4 === 0) {
        cell.classList.add("step-marker-4");
      }
      cell.type = "button";
      cell.dataset.voice = String(voice);
      cell.dataset.step = String(step);
      cell.setAttribute("aria-pressed", "false");
      cell.setAttribute("aria-label", `${PATTERN_VOICE_LABELS[voice]} step ${step + 1}`);

      const flash = document.createElement("span");
      flash.className = "pattern-cell__flash";
      flash.addEventListener("animationend", () => {
        cell.classList.remove("is-current-step");
      });
      cell.appendChild(flash);

      cell.addEventListener("pointerdown", handlePatternCellPointerDown);
      cell.addEventListener("pointerenter", handlePatternCellPointerEnter);
      cell.addEventListener("pointerup", handlePatternCellPointerUp);
      cell.addEventListener("pointercancel", endPatternPaint);
      cell.addEventListener("contextmenu", (event) => event.preventDefault());
      cell.addEventListener("keydown", handlePatternCellKeyDown);

      patternGrid.appendChild(cell);
      patternUI[voice][step] = cell;
    }
  }

  window.addEventListener("pointerup", endPatternPaint);
  window.addEventListener("pointercancel", endPatternPaint, { capture: true });
  window.addEventListener("blur", endPatternPaint);
}

function initSongBuilder() {
  if (!songBuilder) {
    return;
  }

  state.song.slots.fill(state.pattern.slot);
  songBuilder.innerHTML = "";
  songSlotSelects.length = 0;

  for (let index = 0; index < SONG_CHAIN_SLOT_COUNT; index++) {
    const slot = document.createElement("label");
    slot.className = "song-slot";

    const select = document.createElement("select");
    select.className = "song-slot__select";
    select.dataset.songSlot = String(index);
    select.setAttribute("aria-label", `Song slot ${index + 1}`);

    for (let patternIndex = 0; patternIndex < PATTERN_COUNT; patternIndex++) {
      const option = document.createElement("option");
      option.value = String(patternIndex);
      option.textContent = formatPatternSlot(patternIndex);
      select.appendChild(option);
    }

    select.value = String(state.song.slots[index]);
    select.addEventListener("change", handleSongSlotChange);
    slot.append(select);
    songBuilder.appendChild(slot);
    songSlotSelects.push(select);
  }
}

function initSlots() {
  for (let i = 0; i < SLOT_COUNT; i++) {
    const slotEl = document.createElement("div");
    slotEl.className = "slot";
    slotEl.dataset.index = String(i);

    const meta = document.createElement("div");
    meta.className = "slot__meta";

    const title = document.createElement("div");
    title.className = "slot__title";
    const nickname = SLOT_NICKNAMES[i] || "";
    title.textContent = nickname ? `Voice ${i + 1} · ${nickname}` : `Voice ${i + 1}`;

    const details = document.createElement("span");
    details.className = "slot__details";
    details.textContent = "Drop audio or load a file";

    meta.appendChild(title);
    meta.appendChild(details);

    const waveWrap = document.createElement("div");
    waveWrap.className = "slot__wave-wrap";
    const waveCanvas = document.createElement("canvas");
    waveCanvas.className = "slot__wave";
    waveWrap.appendChild(waveCanvas);

    const actions = document.createElement("div");
    actions.className = "slot__actions";

    const loadBtn = document.createElement("button");
    loadBtn.className = "btn ghost slot-load";
    loadBtn.type = "button";
    loadBtn.textContent = "Load";

    const playBtn = document.createElement("button");
    playBtn.className = "btn ghost slot-play";
    playBtn.type = "button";
    playBtn.textContent = "Play";
    playBtn.disabled = true;

    const clearBtn = document.createElement("button");
    clearBtn.className = "btn ghost slot-clear";
    clearBtn.type = "button";
    clearBtn.textContent = "Clear";
    clearBtn.disabled = true;

    actions.append(loadBtn, playBtn, clearBtn);
    slotEl.append(meta, waveWrap, actions);
    slotsContainer.appendChild(slotEl);

    slotUI.push({
      root: slotEl,
      details,
      loadBtn,
      playBtn,
      clearBtn,
      waveCanvas,
    });

    loadBtn.addEventListener("click", () => {
      void openFilePickerForSlot(i);
    });
    playBtn.addEventListener("click", () => playSample(i));
    clearBtn.addEventListener("click", () => clearSlot(i));

    slotEl.addEventListener("dragover", (event) => {
      event.preventDefault();
      slotEl.classList.add("dragover");
    });

    slotEl.addEventListener("dragleave", () => {
      slotEl.classList.remove("dragover");
    });

    slotEl.addEventListener("drop", (event) => {
      event.preventDefault();
      slotEl.classList.remove("dragover");
      const { files } = event.dataTransfer || {};
      if (!files) {
        return;
      }
      handleFileList(files, i);
      event.stopPropagation();
    });

    drawWaveform(waveCanvas, null, null);
    setupWaveformInteractions(i, waveCanvas);
  }
}

function registerEventListeners() {
  if (kitSelect) {
    kitSelect.addEventListener("change", handlePresetSelection);
  }
  if (saveKitBtn) {
    saveKitBtn.addEventListener("click", handleSaveKit);
  }
  if (patternSlotSelect) {
    patternSlotSelect.addEventListener("change", handlePatternSlotChange);
  }
  if (songLengthSelect) {
    songLengthSelect.addEventListener("change", handleSongLengthChange);
  }
  if (clearPatternBtn) {
    clearPatternBtn.addEventListener("click", clearPattern);
  }
  if (randomPatternBtn) {
    randomPatternBtn.addEventListener("click", randomizePattern);
  }
  if (copyPatternBtn) {
    copyPatternBtn.addEventListener("click", copyPattern);
  }
  if (pastePatternBtn) {
    pastePatternBtn.addEventListener("click", pastePattern);
  }
  if (savePatternBtn) {
    savePatternBtn.addEventListener("click", () => {
      void savePatternToDevice();
    });
  }
  settingsSectionButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setActiveSettingsSection(button.dataset.settingsSection || "clock");
    });
  });
  if (analogClockSelect) {
    analogClockSelect.addEventListener("change", handleAnalogClockResolutionChange);
  }
  if (midiClockSelect) {
    midiClockSelect.addEventListener("change", handleMidiClockResolutionChange);
  }
  if (midiChannelSelect) {
    midiChannelSelect.addEventListener("change", handleMidiChannelChange);
  }
  if (legacyMidiToggleBtn) {
    legacyMidiToggleBtn.addEventListener("click", () => {
      setLegacyMidiPanelExpanded(!state.legacyMidi.expanded);
    });
  }
  if (legacyMidiOutputSelect) {
    legacyMidiOutputSelect.addEventListener("pointerdown", () => {
      void ensureLegacyMidiAccess();
    });
    legacyMidiOutputSelect.addEventListener("focus", () => {
      void ensureLegacyMidiAccess();
    });
    legacyMidiOutputSelect.addEventListener("change", handleLegacyMidiOutputChange);
  }
  if (legacyMidiSendBtn) {
    legacyMidiSendBtn.addEventListener("click", () => {
      void sendKitViaLegacyMidi();
    });
  }
  connectBtn.addEventListener("click", connectToSerial);
  if (manualConnectBtn) {
    manualConnectBtn.addEventListener("click", connectToManualSerial);
  }
  uploadBtn.addEventListener("click", () => uploadKit());
  browseBtn.addEventListener("click", () => {
    currentSlotForFile = null;
    void promptForFiles({ multiple: true, accept: KIT_FILE_ACCEPT });
  });

  fileInput.addEventListener("change", (event) => {
    const { files } = event.target;
    if (files && files.length) {
      log(`Picked ${files.length} file${files.length > 1 ? "s" : ""}.`);
      handleFileList(files, currentSlotForFile);
    } else {
      log("File picker closed without selecting a file.");
    }
    currentSlotForFile = null;
    fileInput.value = "";
  });

  ["dragover", "dragenter"].forEach((eventName) => {
    dropZone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropZone.classList.add("dragover");
    });
  });

  ["dragleave", "drop"].forEach((eventName) => {
    dropZone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropZone.classList.remove("dragover");
    });
  });

  dropZone.addEventListener("drop", (event) => {
    const { files } = event.dataTransfer || {};
    if (files && files.length) {
      handleFileList(files, null);
    }
    event.stopPropagation();
  });

}

async function handlePresetSelection(event) {
  const selectEl = event.currentTarget;
  const { value, selectedOptions } = selectEl;
  if (!value) {
    return;
  }

  const label = selectedOptions && selectedOptions.length
    ? selectedOptions[0].textContent.trim()
    : value;

  try {
    selectEl.disabled = true;
    const kitUrl = new URL(value, window.location.href).toString();
    log(`Loading preset kit "${label}" from ${kitUrl}...`);
    const response = await fetch(kitUrl);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const text = await response.text();
    const virtualFile = {
      name: `${label}.d8`,
      async text() {
        return text;
      },
    };
    await loadKitFile(virtualFile, label);
  } catch (error) {
    log(`Failed to load preset kit "${label}": ${error.message}`, "error");
  } finally {
    selectEl.disabled = false;
    selectEl.value = "";
    selectEl.blur();
  }
}

function handleSaveKit() {
  if (state.lastLength === 0) {
    log("No audio to save. Load or record samples first.", "error");
    return;
  }

  try {
    const lines = [];
    for (let i = 0; i < SLOT_COUNT; i++) {
      lines.push(String(state.markersIn[i] ?? 0));
    }
    for (let i = 0; i < SLOT_COUNT; i++) {
      lines.push(String(state.markersOut[i] ?? 0));
    }
    const audioLength = Math.min(
      TOTAL_BUFFER,
      Math.max(state.lastLength, Math.max(...state.markersOut))
    );
    const limit = Math.max(0, Math.floor(audioLength));
    if (!Number.isFinite(limit) || limit <= 0) {
      log("Kit markers are empty. Nothing to save.", "error");
      return;
    }
    for (let i = 0; i < limit; i++) {
      lines.push(String(state.audioBuffer[i] ?? 127));
    }
    const payload = `${lines.join("\n")}\n`;
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    const filename = `deton8-kit-${timestamp}.d8`;
    const blob = new Blob([payload], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    requestAnimationFrame(() => {
      URL.revokeObjectURL(url);
      anchor.remove();
    });
    log(`Saved kit as ${filename}.`);
  } catch (error) {
    log(`Failed to save kit: ${error.message}`, "error");
  }
}

function registerGlobalDragGuards() {
  const guard = (event) => {
    if (isWithinDropTargets(event.target)) {
      return;
    }
    event.preventDefault();
  };

  ["dragenter", "dragover"].forEach((eventName) => {
    window.addEventListener(eventName, guard, true);
  });

  window.addEventListener("drop", (event) => {
    if (isWithinDropTargets(event.target)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }, true);
}

function isWithinDropTargets(target) {
  if (!target) {
    return false;
  }
  return dropZone.contains(target) || slotsContainer.contains(target);
}

function handlePatternSlotChange(event) {
  const nextSlot = Number.parseInt(event.currentTarget.value, 10);
  state.pattern.slot = clamp(nextSlot, 0, PATTERN_COUNT - 1);
  state.pattern.steps = state.pattern.patterns[state.pattern.slot];
  if (!state.song.dirty && !state.song.loaded) {
    fillSongBuilderWithCurrentPattern();
  }
  renderPatternEditor();
  void cuePatternOnDevice(state.pattern.slot);
}

function handleSongSlotChange(event) {
  const slotIndex = Number.parseInt(event.currentTarget.dataset.songSlot || "", 10);
  const patternIndex = Number.parseInt(event.currentTarget.value, 10);
  if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex >= SONG_CHAIN_SLOT_COUNT) {
    return;
  }
  if (slotIndex >= state.song.length) {
    renderSongBuilder();
    return;
  }

  state.song.slots[slotIndex] = clamp(patternIndex, 0, PATTERN_COUNT - 1);
  state.song.dirty = true;
  state.song.loaded = true;
  songLocalEditAt = Date.now();
  renderSongBuilder();
  updateControls();
  scheduleSongAutoSend();
}

function handleSongLengthChange(event) {
  const nextLength = Number.parseInt(event.currentTarget.value, 10);
  state.song.length = clamp(nextLength, 1, SONG_CHAIN_SLOT_COUNT);
  state.song.dirty = true;
  state.song.loaded = true;
  songLocalEditAt = Date.now();
  renderSongBuilder();
  updateControls();
  scheduleSongAutoSend();
}

function fillSongBuilderWithCurrentPattern() {
  state.song.slots.fill(clamp(state.pattern.slot | 0, 0, PATTERN_COUNT - 1));
  renderSongBuilder();
}

function setActiveSettingsSection(section) {
  state.settings.activeSection = section === "midi" ? "midi" : "clock";
  renderSettingsEditor();
}

function normalizeClockResolution(value) {
  return Number(value) === CLOCK_RESOLUTION_STEP ? CLOCK_RESOLUTION_STEP : CLOCK_RESOLUTION_NORMAL;
}

function renderSettingsEditor() {
  const activeSection = state.settings.activeSection === "midi" ? "midi" : "clock";
  settingsSectionButtons.forEach((button) => {
    const active = button.dataset.settingsSection === activeSection;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-selected", active ? "true" : "false");
    button.tabIndex = active ? 0 : -1;
  });

  settingsPages.forEach((page) => {
    const active = page.dataset.settingsPage === activeSection;
    page.hidden = !active;
  });

  if (analogClockSelect && analogClockSelect.value !== String(state.settings.analogClockResolution)) {
    analogClockSelect.value = String(state.settings.analogClockResolution);
  }
  if (midiClockSelect && midiClockSelect.value !== String(state.settings.midiClockResolution)) {
    midiClockSelect.value = String(state.settings.midiClockResolution);
  }
  if (midiChannelSelect && midiChannelSelect.value !== String(state.settings.midiChannel)) {
    midiChannelSelect.value = String(state.settings.midiChannel);
  }
}

function applyLocalSettingsChange(changes) {
  if (!state.port) {
    renderSettingsEditor();
    log("Connect to deton8 before changing settings.", "error");
    return;
  }

  state.settings = {
    ...state.settings,
    ...changes,
    loaded: true,
  };
  settingsLocalEditAt = Date.now();
  renderSettingsEditor();
  updateControls();
  void transmitSettings();
}

function handleAnalogClockResolutionChange(event) {
  applyLocalSettingsChange({
    analogClockResolution: normalizeClockResolution(event.currentTarget.value),
  });
}

function handleMidiClockResolutionChange(event) {
  applyLocalSettingsChange({
    midiClockResolution: normalizeClockResolution(event.currentTarget.value),
  });
}

function handleMidiChannelChange(event) {
  const nextChannel = clamp(Number.parseInt(event.currentTarget.value, 10), 1, 16);
  applyLocalSettingsChange({ midiChannel: nextChannel });
}

function handlePatternCellPointerDown(event) {
  if (event.button !== 0) {
    return;
  }

  const { voice, step } = getPatternCellPosition(event.currentTarget);
  if (voice === -1 || step === -1) {
    return;
  }

  event.preventDefault();
  const isActive = isPatternStepActive(voice, step);
  patternPaint.active = true;
  patternPaint.mode = isActive ? "erase" : "fill";
  patternPaint.pointerId = event.pointerId ?? null;
  patternPaint.lastKey = null;

  try {
    event.currentTarget.setPointerCapture(patternPaint.pointerId);
  } catch (error) {
    // Pointer capture is optional for this paint interaction.
  }

  applyPatternPaint(voice, step, patternPaint.mode);
}

function handlePatternCellPointerEnter(event) {
  if (!patternPaint.active) {
    return;
  }
  if (patternPaint.pointerId !== null && event.pointerId !== patternPaint.pointerId) {
    return;
  }
  if ((event.buttons & 1) === 0) {
    endPatternPaint();
    return;
  }

  const { voice, step } = getPatternCellPosition(event.currentTarget);
  applyPatternPaint(voice, step, patternPaint.mode);
}

function handlePatternCellPointerUp(event) {
  if (patternPaint.pointerId !== null && event.pointerId !== patternPaint.pointerId) {
    return;
  }
  endPatternPaint();
}

function handlePatternCellKeyDown(event) {
  if (event.repeat || (event.code !== "Space" && event.code !== "Enter")) {
    return;
  }

  const { voice, step } = getPatternCellPosition(event.currentTarget);
  if (voice === -1 || step === -1) {
    return;
  }

  event.preventDefault();
  setPatternStep(voice, step, !isPatternStepActive(voice, step));
}

function endPatternPaint() {
  patternPaint.active = false;
  patternPaint.mode = null;
  patternPaint.pointerId = null;
  patternPaint.lastKey = null;
}

function getPatternCellPosition(cell) {
  const voice = Number.parseInt(cell && cell.dataset ? cell.dataset.voice : "", 10);
  const step = Number.parseInt(cell && cell.dataset ? cell.dataset.step : "", 10);
  if (!Number.isInteger(voice) || !Number.isInteger(step)) {
    return { voice: -1, step: -1 };
  }
  return { voice, step };
}

function applyPatternPaint(voice, step, mode) {
  if (voice < 0 || step < 0 || !mode) {
    return;
  }

  const key = `${voice}:${step}`;
  if (patternPaint.lastKey === key) {
    return;
  }
  patternPaint.lastKey = key;
  setPatternStep(voice, step, mode === "fill");
}

function isPatternStepActive(voice, step) {
  if (!isValidPatternPosition(voice, step)) {
    return false;
  }
  return !!(state.pattern.steps[step] & (1 << voice));
}

function setPatternStep(voice, step, active) {
  if (!isValidPatternPosition(voice, step)) {
    return;
  }

  const bit = 1 << voice;
  const currentMask = state.pattern.steps[step] ?? 0;
  const nextMask = active ? currentMask | bit : currentMask & ~bit;
  if (nextMask === currentMask) {
    return;
  }

  state.pattern.steps[step] = nextMask;
  renderPatternEditor();
  flashPatternCell(voice, step);
  schedulePatternAutoSend();
}

function isValidPatternPosition(voice, step) {
  return Number.isInteger(voice) &&
    Number.isInteger(step) &&
    voice >= 0 &&
    voice < PATTERN_VOICE_COUNT &&
    step >= 0 &&
    step < PATTERN_STEP_COUNT;
}

function renderPatternEditor() {
  if (patternSlotSelect && patternSlotSelect.value !== String(state.pattern.slot)) {
    patternSlotSelect.value = String(state.pattern.slot);
  }
  renderSongBuilder();

  for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
    const mask = state.pattern.steps[step] ?? 0;
    for (let voice = 0; voice < PATTERN_VOICE_COUNT; voice++) {
      const cell = patternUI[voice] && patternUI[voice][step];
      if (!cell) {
        continue;
      }
      const active = !!(mask & (1 << voice));
      cell.classList.toggle("active", active);
      cell.setAttribute("aria-pressed", active ? "true" : "false");
    }
  }
}

function renderSongBuilder() {
  if (songLengthSelect && songLengthSelect.value !== String(state.song.length)) {
    songLengthSelect.value = String(state.song.length);
  }
  for (let index = 0; index < songSlotSelects.length; index++) {
    const select = songSlotSelects[index];
    if (!select) {
      continue;
    }
    const active = index < state.song.length;
    const root = select.closest(".song-slot");
    if (root) {
      root.classList.toggle("is-inactive", !active);
    }
    const nextValue = String(clamp(state.song.slots[index] ?? 0, 0, PATTERN_COUNT - 1));
    if (select.value !== nextValue) {
      select.value = nextValue;
    }
  }
}

function clearPattern() {
  state.pattern.steps.fill(0);
  renderPatternEditor();
  log(`Cleared pattern ${formatPatternSlot(state.pattern.slot)}.`);
  schedulePatternAutoSend({ immediate: true });
}

function randomizePattern() {
  for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
    let mask = 0;
    if (step % 4 === 0) {
      mask |= 1 << 0;
    }
    if (step % 8 === 4) {
      mask |= 1 << 1;
    }
    if (step % 2 === 0 && Math.random() > 0.35) {
      mask |= 1 << 2;
    }
    for (let voice = 3; voice < PATTERN_VOICE_COUNT; voice++) {
      const probability = voice === 7 ? 0.14 : 0.18;
      if (Math.random() < probability) {
        mask |= 1 << voice;
      }
    }
    state.pattern.steps[step] = mask;
  }
  renderPatternEditor();
  log(`Randomized pattern ${formatPatternSlot(state.pattern.slot)}.`);
  schedulePatternAutoSend({ immediate: true });
}

function copyPattern() {
  state.pattern.clipboard = new Uint8Array(state.pattern.steps);
  state.pattern.clipboardSlot = state.pattern.slot;
  if (copyPatternFeedbackTimer) {
    clearTimeout(copyPatternFeedbackTimer);
  }
  if (copyPatternBtn) {
    copyPatternBtn.textContent = `Copied ${formatPatternSlot(state.pattern.slot)}`;
    copyPatternFeedbackTimer = setTimeout(() => {
      copyPatternFeedbackTimer = null;
      copyPatternBtn.textContent = "Copy";
    }, 900);
  }
  updateControls();
  log(`Copied pattern ${formatPatternSlot(state.pattern.slot)}.`);
}

function pastePattern() {
  if (!state.pattern.clipboard) {
    return;
  }

  state.pattern.steps.set(state.pattern.clipboard);
  renderPatternEditor();
  log(`Pasted pattern ${formatPatternSlot(state.pattern.clipboardSlot)} to ${formatPatternSlot(state.pattern.slot)}.`);
  schedulePatternAutoSend({ immediate: true });
}

function flashPatternCell(voice, step) {
  const cell = patternUI[voice] && patternUI[voice][step];
  if (!cell) {
    return;
  }
  cell.classList.remove("is-current-step");
  // Force the CSS animation to restart when repeatedly editing the same cell.
  cell.offsetWidth;
  cell.classList.add("is-current-step");
}

function flashDeviceStep(step) {
  if (step < 0 || step >= PATTERN_STEP_COUNT) {
    return;
  }

  if (deviceStepFlashTimers[step]) {
    clearTimeout(deviceStepFlashTimers[step]);
    deviceStepFlashTimers[step] = null;
  }

  for (let voice = 0; voice < PATTERN_VOICE_COUNT; voice++) {
    const cell = patternUI[voice] && patternUI[voice][step];
    if (!cell) {
      continue;
    }
    cell.classList.remove("is-device-step");
    cell.offsetWidth;
    cell.classList.add("is-device-step");
  }

  deviceStepFlashTimers[step] = setTimeout(() => {
    for (let voice = 0; voice < PATTERN_VOICE_COUNT; voice++) {
      const cell = patternUI[voice] && patternUI[voice][step];
      if (cell) {
        cell.classList.remove("is-device-step");
      }
    }
    deviceStepFlashTimers[step] = null;
  }, 190);
}

function formatPatternSlot(slot) {
  return String(clamp((slot | 0) + 1, 1, PATTERN_COUNT)).padStart(2, "0");
}

async function openFilePickerForSlot(slotIndex) {
  currentSlotForFile = slotIndex;
  await promptForFiles({ multiple: false, accept: AUDIO_FILE_ACCEPT });
}

async function promptForFiles({ multiple, accept }) {
  if (location.protocol === "file:") {
    log("Launching picker from file://. Use a local server (e.g. `python3 -m http.server`) if Chrome keeps blocking access.", "error");
  }

  fileInput.multiple = Boolean(multiple);
  if (multiple) {
    fileInput.setAttribute("multiple", "");
  } else {
    fileInput.removeAttribute("multiple");
  }

  if (accept) {
    fileInput.accept = accept;
    fileInput.setAttribute("accept", accept);
  } else {
    fileInput.accept = "";
    fileInput.removeAttribute("accept");
  }

  fileInput.value = "";

  const canUseShowPicker = typeof fileInput.showPicker === "function" && window.isSecureContext;

  if (canUseShowPicker) {
    try {
      await fileInput.showPicker();
      return;
    } catch (error) {
      if (error && error.name === "AbortError") {
        return;
      }
      if (error && error.name === "NotAllowedError" && !window.isSecureContext) {
        // fall through to .click()
      } else if (error) {
        log(`File picker error: ${error.message}`, "error");
      }
    }
  }

  try {
    fileInput.click();
    log("File picker opened via click fallback.");
  } catch (error) {
    log(`File picker error: ${error.message}`, "error");
  }
}

function canUseWebSerial() {
  return "serial" in navigator && window.isSecureContext;
}

function canUseWebMidi() {
  return "requestMIDIAccess" in navigator && window.isSecureContext;
}

function setLegacyMidiPanelExpanded(expanded) {
  const nextExpanded = !!expanded;
  state.legacyMidi.expanded = nextExpanded;

  if (legacyMidiContainer) {
    legacyMidiContainer.classList.toggle("is-open", nextExpanded);
  }
  if (legacyMidiToggleBtn) {
    legacyMidiToggleBtn.setAttribute("aria-expanded", nextExpanded ? "true" : "false");
  }
  if (legacyMidiPanel) {
    legacyMidiPanel.setAttribute("aria-hidden", nextExpanded ? "false" : "true");
    if (!nextExpanded && legacyMidiPanel.contains(document.activeElement) && legacyMidiToggleBtn) {
      legacyMidiToggleBtn.focus();
    }
  }

  updateControls();
  if (nextExpanded) {
    void ensureLegacyMidiAccess();
  }
}

async function ensureLegacyMidiAccess() {
  if (!canUseWebMidi()) {
    refreshLegacyMidiOutputs();
    return null;
  }
  if (state.legacyMidi.access) {
    refreshLegacyMidiOutputs();
    return state.legacyMidi.access;
  }
  if (state.legacyMidi.opening) {
    return null;
  }

  state.legacyMidi.opening = true;
  updateControls();

  try {
    const access = await navigator.requestMIDIAccess({ sysex: true });
    state.legacyMidi.access = access;
    access.onstatechange = () => {
      refreshLegacyMidiOutputs();
      updateControls();
    };
    refreshLegacyMidiOutputs();
    log("Legacy MIDI access ready.");
    return access;
  } catch (error) {
    log(`Legacy MIDI access failed: ${error.message}`, "error");
    refreshLegacyMidiOutputs();
    return null;
  } finally {
    state.legacyMidi.opening = false;
    updateControls();
  }
}

function refreshLegacyMidiOutputs() {
  const access = state.legacyMidi.access;
  const outputs = access ? Array.from(access.outputs.values()) : [];
  state.legacyMidi.outputs = outputs;

  if (state.legacyMidi.outputId && !outputs.some((output) => output.id === state.legacyMidi.outputId)) {
    state.legacyMidi.outputId = "";
  }

  if (!legacyMidiOutputSelect) {
    return;
  }

  const currentValue = state.legacyMidi.outputId || legacyMidiOutputSelect.value || "";
  legacyMidiOutputSelect.innerHTML = "";

  const placeholder = document.createElement("option");
  placeholder.value = "";
  if (!canUseWebMidi()) {
    placeholder.textContent = "MIDI unavailable";
  } else if (!state.legacyMidi.access) {
    placeholder.textContent = "Choose MIDI output...";
  } else if (outputs.length === 0) {
    placeholder.textContent = "No MIDI outputs";
  } else {
    placeholder.textContent = "Choose MIDI output...";
  }
  legacyMidiOutputSelect.appendChild(placeholder);

  for (const output of outputs) {
    const option = document.createElement("option");
    option.value = output.id;
    option.textContent = output.name || output.manufacturer || `MIDI output ${legacyMidiOutputSelect.options.length}`;
    legacyMidiOutputSelect.appendChild(option);
  }

  const nextValue = outputs.some((output) => output.id === currentValue) ? currentValue : "";
  legacyMidiOutputSelect.value = nextValue;
  state.legacyMidi.outputId = nextValue;
}

function handleLegacyMidiOutputChange(event) {
  state.legacyMidi.outputId = event.currentTarget.value || "";
  updateControls();
}

function getSelectedLegacyMidiOutput() {
  return state.legacyMidi.outputs.find((output) => output.id === state.legacyMidi.outputId) || null;
}

function setupWaveformInteractions(slotIndex, canvas) {
  let dragging = false;
  let pointerId = null;
  let dragStartRatio = 0;
  let didMove = false;
  let initialSelection = null;

  const handlePointerDown = (event) => {
    const sample = state.samples[slotIndex];
    if (!sample || !sample.floats || !sample.floats.length) {
      return;
    }
    dragging = true;
    pointerId = event.pointerId;
    dragStartRatio = getPointerRatio(event, canvas);
    try {
      canvas.setPointerCapture(pointerId);
    } catch (err) {
      // ignore inability to capture pointer
    }
    const selection = getSampleSelection(sample);
    initialSelection = { start: selection.start, end: selection.end };
    didMove = false;
    event.preventDefault();
  };

  const handlePointerMove = (event) => {
    if (!dragging) {
      return;
    }
    const sample = state.samples[slotIndex];
    if (!sample || !sample.floats || !sample.floats.length) {
      return;
    }
    const currentRatio = getPointerRatio(event, canvas);
    applySelection(slotIndex, dragStartRatio, currentRatio, false);
    didMove = true;
    event.preventDefault();
  };

  const finishDrag = (event) => {
    if (!dragging) {
      return;
    }
    const sample = state.samples[slotIndex];
    if (sample && sample.floats && sample.floats.length) {
      if (didMove) {
        const endRatio = getPointerRatio(event, canvas);
        applySelection(slotIndex, dragStartRatio, endRatio, true);
      } else if (initialSelection) {
        sample.selection = { start: initialSelection.start, end: initialSelection.end };
        const ui = slotUI[slotIndex];
        if (ui) {
          drawWaveform(ui.waveCanvas, sample.floats || null, sample.selection);
        }
      }
    }
    if (pointerId !== null) {
      try {
        canvas.releasePointerCapture(pointerId);
      } catch (err) {
        // ignore
      }
    }
    dragging = false;
    pointerId = null;
    initialSelection = null;
    event.preventDefault();
  };

  canvas.addEventListener("pointerdown", handlePointerDown);
  canvas.addEventListener("pointermove", handlePointerMove);
  canvas.addEventListener("pointerup", finishDrag);
  canvas.addEventListener("pointercancel", finishDrag);
  canvas.addEventListener("pointerleave", (event) => {
    if (dragging) {
      finishDrag(event);
    }
  });
  canvas.addEventListener("dblclick", (event) => {
    const sample = state.samples[slotIndex];
    if (!sample || !sample.bytes || !sample.bytes.length) {
      return;
    }
    sample.selection = { start: 0, end: sample.bytes.length };
    const ui = slotUI[slotIndex];
    if (ui) {
      drawWaveform(ui.waveCanvas, sample.floats || null, sample.selection);
    }
    rebuildKit();
    renderSlots();
    event.preventDefault();
  });
}

function applySelection(slotIndex, ratioA, ratioB, finalize) {
  const sample = state.samples[slotIndex];
  if (!sample || !sample.bytes || !sample.bytes.length) {
    return;
  }

  const length = sample.bytes.length;
  const startRatio = clamp(Math.min(ratioA, ratioB), 0, 1);
  const endRatio = clamp(Math.max(ratioA, ratioB), 0, 1);
  let startIndex = Math.floor(startRatio * length);
  let endIndex = Math.ceil(endRatio * length);

  if (endIndex > length) {
    endIndex = length;
  }
  if (endIndex <= startIndex) {
    endIndex = Math.min(length, startIndex + 1);
  }

  if (!sample.selection) {
    sample.selection = { start: startIndex, end: endIndex };
  } else {
    sample.selection.start = startIndex;
    sample.selection.end = endIndex;
  }

  const ui = slotUI[slotIndex];
  if (ui) {
    drawWaveform(ui.waveCanvas, sample.floats || null, sample.selection);
  }

  if (finalize) {
    rebuildKit();
    renderSlots();
  }
}

function getPointerRatio(event, canvas) {
  const rect = canvas.getBoundingClientRect();
  if (!rect.width) {
    return 0;
  }
  const ratio = (event.clientX - rect.left) / rect.width;
  return clamp(ratio, 0, 1);
}

function getSampleSelection(sample) {
  if (!sample || !sample.bytes) {
    return { start: 0, end: 0 };
  }
  const length = sample.bytes.length;
  if (!sample.selection) {
    sample.selection = { start: 0, end: length };
  }
  let { start, end } = sample.selection;
  start = clamp(Math.floor(start), 0, length);
  end = clamp(Math.ceil(end), 0, length);
  if (end <= start) {
    end = Math.min(length, start + 1);
  }
  sample.selection.start = start;
  sample.selection.end = end;
  return sample.selection;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function handleFileList(fileList, targetSlot) {
  const files = Array.from(fileList);
  files.reduce(
    (promise, file) =>
      promise.then(() => handleFile(file, targetSlot)),
    Promise.resolve()
  );
}

async function handleFile(file, targetSlot) {
  const extension = getExtension(file.name);

  if (extension === "d8") {
    await loadKitFile(file);
    return;
  }

  if (!SUPPORTED_AUDIO.has(extension)) {
    log(`Skipping unsupported file: ${file.name}`, "error");
    return;
  }

  await loadAudioFile(file, targetSlot);
}

async function loadAudioFile(file, targetSlot) {
  try {
    const ctx = await ensureAudioContext();
    const arrayBuffer = await file.arrayBuffer();
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer.slice(0));

    const floatData = mixToMono(audioBuffer);
    const bytes = float32ToUint8(floatData);

    const slotIndex = Number.isInteger(targetSlot) ? targetSlot : findFirstEmptySlot();
    if (slotIndex === -1) {
      log("All slots are already populated. Clear one before adding more.", "error");
      return;
    }

    state.samples[slotIndex] = {
      name: file.name,
      bytes,
      floats: floatData,
      sampleRate: audioBuffer.sampleRate,
      durationSec: floatData.length / audioBuffer.sampleRate,
      fromKit: false,
      selection: { start: 0, end: bytes.length },
    };

    rebuildKit();
    renderSlots();
    log(`Loaded ${file.name} into voice ${slotIndex + 1}.`);
  } catch (error) {
    log(`Failed to decode ${file.name}: ${error.message}`, "error");
  }
}

async function loadKitFile(source, displayName) {
  const kitName = displayName || (source && source.name) || "kit.d8";
  try {
    const text = typeof source === "string" ? source : await source.text();
    const lines = text
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (lines.length < SLOT_COUNT * 2) {
      throw new Error("Kit file is too short.");
    }

    const values = lines.map((line) => {
      const parsed = Number.parseInt(line, 10);
      if (Number.isNaN(parsed)) {
        throw new Error(`Invalid number in kit file: "${line}"`);
      }
      return parsed;
    });

    const inMarkers = values.slice(0, SLOT_COUNT).map(clampMarker);
    const outMarkers = values.slice(SLOT_COUNT, SLOT_COUNT * 2).map(clampMarker);
    const audioValues = values.slice(SLOT_COUNT * 2);

    state.audioBuffer.fill(127);
    const limit = Math.min(audioValues.length, state.audioBuffer.length);
    for (let i = 0; i < limit; i++) {
      state.audioBuffer[i] = clampByte(audioValues[i]);
    }

    state.markersIn.set(inMarkers);
    state.markersOut.set(outMarkers);
    state.lastLength = Math.min(TOTAL_BUFFER, Math.max(...outMarkers));

    const samples = Array.from({ length: SLOT_COUNT }, (_, index) => {
      const start = Math.min(state.audioBuffer.length - 1, inMarkers[index]);
      const end = Math.min(state.audioBuffer.length - 1, outMarkers[index]);
      if (end <= start) {
        return null;
      }
      const length = end - start;
      const slice = new Uint8Array(length);
      slice.set(state.audioBuffer.subarray(start, end), 0);
      return {
        name: `Kit slot ${index + 1}`,
        bytes: slice,
        floats: bytesToFloat32(slice),
        sampleRate: DEFAULT_SAMPLE_RATE,
        durationSec: length / DEFAULT_SAMPLE_RATE,
        fromKit: true,
        selection: { start: 0, end: slice.length },
      };
    });

    state.samples = samples;
    rebuildKit();
    renderSlots();
    log(`Loaded kit from ${kitName}.`);
  } catch (error) {
    log(`Failed to load kit ${kitName}: ${error.message}`, "error");
  }
}

function rebuildKit() {
  state.audioBuffer.fill(127);
  const newIn = new Uint16Array(SLOT_COUNT);
  const newOut = new Uint16Array(SLOT_COUNT);
  const segments = [];
  let cursor = 0;

  for (let i = 0; i < SLOT_COUNT; i++) {
    const sample = state.samples[i];
    newIn[i] = cursor;
    if (sample && sample.bytes && sample.bytes.length) {
      const selection = getSampleSelection(sample);
      const slice = sample.bytes.slice(selection.start, selection.end);
      if (slice.length > 0) {
        segments.push(slice);
        cursor += slice.length;
      }
    }
    newOut[i] = cursor;
  }

  state.markersIn.set(newIn);
  state.markersOut.set(newOut);
  state.lastLength = cursor;

  if (cursor === 0) {
    state.audioBuffer[TOTAL_BUFFER] = 127;
    updateSlotCount();
    updateControls();
    return;
  }

  const raw = new Uint8Array(cursor);
  let offset = 0;
  for (const segment of segments) {
    raw.set(segment, offset);
    offset += segment.length;
  }

  if (cursor <= TOTAL_BUFFER) {
    state.audioBuffer.set(raw, 0);
    state.lastLength = cursor;
  } else {
    const ratio = TOTAL_BUFFER / cursor;
    for (let i = 0; i < SLOT_COUNT; i++) {
      state.markersIn[i] = Math.floor(newIn[i] * ratio);
      state.markersOut[i] = Math.floor(newOut[i] * ratio);
    }
    for (let i = 0; i < TOTAL_BUFFER; i++) {
      const srcIndex = Math.floor((i / TOTAL_BUFFER) * cursor);
      state.audioBuffer[i] = raw[srcIndex];
    }
    state.lastLength = TOTAL_BUFFER;
  }

  state.audioBuffer[TOTAL_BUFFER] = 127;
  updateSlotCount();
  updateControls();
}

function renderSlots() {
  for (let i = 0; i < SLOT_COUNT; i++) {
    const sample = state.samples[i];
    const ui = slotUI[i];
    if (!sample) {
      ui.details.textContent = "Empty slot";
      ui.loadBtn.textContent = "Load";
      ui.playBtn.disabled = true;
      ui.clearBtn.disabled = true;
      drawWaveform(ui.waveCanvas, null, null);
      continue;
    }

    const selection = getSampleSelection(sample);
    const selectedSamples = selection.end - selection.start;
    const totalSamples = sample.bytes.length;
    const lengthInfo = totalSamples === selectedSamples
      ? `${formatNumber(selectedSamples)} samples`
      : `${formatNumber(selectedSamples)} selected / ${formatNumber(totalSamples)} total`;
    const duration = formatDuration(selectedSamples / (sample.sampleRate || DEFAULT_SAMPLE_RATE));
    const descriptor = sample.name ? truncate(sample.name, 42) : `Voice ${i + 1}`;
    ui.details.textContent = `${descriptor} • ${lengthInfo} • ${duration}`;
    ui.loadBtn.textContent = "Replace";
    ui.playBtn.disabled = false;
    ui.clearBtn.disabled = false;
    drawWaveform(ui.waveCanvas, sample.floats || null, selection);
  }
  updateControls();
}

function clearSlot(index) {
  if (!state.samples[index]) {
    return;
  }
  const name = state.samples[index].name || `Voice ${index + 1}`;
  state.samples[index] = null;
  rebuildKit();
  renderSlots();
  log(`Cleared ${name} from voice ${index + 1}.`);
}

async function playSample(index) {
  const sample = state.samples[index];
  if (!sample) {
    return;
  }
  const selection = getSampleSelection(sample);
  const length = selection.end - selection.start;
  if (!sample.floats || !sample.floats.length || length <= 0) {
    return;
  }
  try {
    const ctx = await ensureAudioContext();
    const buffer = ctx.createBuffer(1, length, sample.sampleRate || DEFAULT_SAMPLE_RATE);
    const slice = sample.floats.subarray(selection.start, selection.end);
    buffer.copyToChannel(slice, 0, 0);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start();
  } catch (error) {
    log(`Failed to play sample: ${error.message}`, "error");
  }
}

function schedulePatternAutoSend({ immediate = false } = {}) {
  if (applyingRemotePattern) {
    return;
  }
  patternLocalEditAt[state.pattern.slot] = Date.now();
  if (patternAutoSendTimer) {
    clearTimeout(patternAutoSendTimer);
  }
  patternAutoSendTimer = setTimeout(() => {
    patternAutoSendTimer = null;
    void transmitPattern({ silent: true });
  }, immediate ? 0 : PATTERN_AUTO_SEND_DELAY_MS);
}

function scheduleSongAutoSend({ immediate = false } = {}) {
  if (songAutoSendTimer) {
    clearTimeout(songAutoSendTimer);
  }
  songAutoSendTimer = setTimeout(() => {
    songAutoSendTimer = null;
    void transmitSongChain({ silent: true });
  }, immediate ? 0 : PATTERN_AUTO_SEND_DELAY_MS);
}

function flushQueuedPatternWork() {
  if (state.uploading || state.patternTransfer) {
    return;
  }
  if (patternAutoSendQueued) {
    patternAutoSendQueued = false;
    schedulePatternAutoSend({ immediate: true });
    return;
  }
  if (songAutoSendQueued) {
    songAutoSendQueued = false;
    scheduleSongAutoSend({ immediate: true });
  }
}

async function transmitPattern({ silent = false } = {}) {
  if (!state.port) {
    return false;
  }
  if (state.uploading) {
    return false;
  }
  if (state.patternTransfer) {
    patternAutoSendQueued = true;
    return false;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    const frame = buildPatternFrame();
    const payload = new Uint8Array(frame.length + 1);
    payload[0] = PATTERN_SEND_COMMAND;
    payload.set(frame, 1);

    writer = state.port.writable.getWriter();
    await writer.write(payload);
    if (!silent) {
      log(`Synced pattern ${formatPatternSlot(state.pattern.slot)} to deton8.`);
    }
    return true;
  } catch (error) {
    log(`Pattern sync failed: ${error.message}`, "error");
    return false;
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function transmitSongChain({ silent = false } = {}) {
  if (!state.port) {
    return false;
  }
  if (state.uploading) {
    return false;
  }
  if (state.patternTransfer) {
    songAutoSendQueued = true;
    return false;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    const frame = buildSongChainFrame();
    const payload = new Uint8Array(frame.length + 1);
    payload[0] = PATTERN_CHAIN_COMMAND;
    payload.set(frame, 1);

    writer = state.port.writable.getWriter();
    await writer.write(payload);
    if (!silent) {
      log("Synced song sequence to deton8.");
    }
    return true;
  } catch (error) {
    log(`Song sync failed: ${error.message}`, "error");
    return false;
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function transmitSettings({ silent = false } = {}) {
  if (!state.port) {
    return false;
  }
  if (state.uploading || state.patternTransfer) {
    return false;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    const frame = buildSettingsFrame();
    const payload = new Uint8Array(frame.length + 1);
    payload[0] = SETTINGS_COMMAND;
    payload.set(frame, 1);

    writer = state.port.writable.getWriter();
    await writer.write(payload);
    if (!silent) {
      log("Synced settings to deton8.");
    }
    return true;
  } catch (error) {
    log(`Settings sync failed: ${error.message}`, "error");
    return false;
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function savePatternToDevice() {
  if (!state.port) {
    log("Connect to deton8 before saving the pattern.", "error");
    return;
  }
  if (state.uploading || state.patternTransfer) {
    log("Pattern is busy. Try Save again in a moment.", "warn");
    return;
  }

  if (patternAutoSendTimer) {
    clearTimeout(patternAutoSendTimer);
    patternAutoSendTimer = null;
  }
  if (songAutoSendTimer) {
    clearTimeout(songAutoSendTimer);
    songAutoSendTimer = null;
  }

  const synced = await transmitPattern({ silent: true });
  if (!synced || !state.port || state.uploading || state.patternTransfer) {
    return;
  }
  if (state.song.dirty || songAutoSendQueued) {
    const songSynced = await transmitSongChain({ silent: true });
    if (!songSynced || !state.port || state.uploading || state.patternTransfer) {
      return;
    }
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    writer = state.port.writable.getWriter();
    await writer.write(Uint8Array.from([PATTERN_SAVE_COMMAND]));
    log(state.song.dirty
      ? `Saved pattern ${formatPatternSlot(state.pattern.slot)} and song to deton8.`
      : `Saved pattern ${formatPatternSlot(state.pattern.slot)} to deton8.`);
  } catch (error) {
    log(`Pattern save failed: ${error.message}`, "error");
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function cuePatternOnDevice(slot) {
  if (!state.port || state.uploading) {
    return;
  }
  if (state.patternTransfer) {
    setTimeout(() => {
      void cuePatternOnDevice(slot);
    }, PATTERN_AUTO_SEND_DELAY_MS);
    return;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    const nextSlot = clamp(slot | 0, 0, PATTERN_COUNT - 1);
    writer = state.port.writable.getWriter();
    patternRefreshStartedAt[nextSlot] = Date.now();
    await writer.write(Uint8Array.from([PATTERN_CUE_COMMAND, nextSlot]));
    log(`Cued pattern ${formatPatternSlot(nextSlot)} on deton8.`);
  } catch (error) {
    log(`Pattern cue failed: ${error.message}`, "error");
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function requestPatternFromDevice(slot) {
  if (!state.port || state.uploading || state.patternTransfer) {
    return;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    const requestedSlot = slot === PATTERN_CURRENT_SLOT ? PATTERN_CURRENT_SLOT : clamp(slot | 0, 0, PATTERN_COUNT - 1);
    writer = state.port.writable.getWriter();
    if (requestedSlot === PATTERN_CURRENT_SLOT) {
      patternRefreshStartedAt.fill(Date.now());
    } else {
      patternRefreshStartedAt[requestedSlot] = Date.now();
    }
    await writer.write(Uint8Array.from([PATTERN_REQUEST_COMMAND, requestedSlot]));
  } catch (error) {
    log(`Pattern refresh failed: ${error.message}`, "error");
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function requestSongChainFromDevice() {
  if (!state.port || state.uploading || state.patternTransfer) {
    return;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    writer = state.port.writable.getWriter();
    songRefreshStartedAt = Date.now();
    await writer.write(Uint8Array.from([PATTERN_CHAIN_REQUEST_COMMAND]));
  } catch (error) {
    log(`Song refresh failed: ${error.message}`, "error");
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function requestSettingsFromDevice() {
  if (!state.port || state.uploading || state.patternTransfer) {
    return;
  }

  state.patternTransfer = true;
  updateControls();

  let writer;
  try {
    writer = state.port.writable.getWriter();
    settingsRefreshStartedAt = Date.now();
    await writer.write(Uint8Array.from([SETTINGS_REQUEST_COMMAND]));
  } catch (error) {
    log(`Settings refresh failed: ${error.message}`, "error");
  } finally {
    if (writer) {
      writer.releaseLock();
    }
    state.patternTransfer = false;
    updateControls();
    flushQueuedPatternWork();
  }
}

async function requestDeviceEditorState() {
  await requestPatternFromDevice(PATTERN_CURRENT_SLOT);
  await requestSongChainFromDevice();
  await requestSettingsFromDevice();
}

function buildPatternFrame() {
  const frame = new Uint8Array(PATTERN_FRAME_BYTES);
  let offset = 0;
  frame.set(PATTERN_MAGIC, offset);
  offset += PATTERN_MAGIC.length;
  frame[offset++] = PATTERN_VERSION;
  frame[offset++] = clamp(state.pattern.slot | 0, 0, PATTERN_COUNT - 1);
  frame[offset++] = PATTERN_STEP_COUNT;
  frame[offset++] = PATTERN_VOICE_COUNT;
  for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
    frame[offset++] = state.pattern.steps[step] & ((1 << PATTERN_VOICE_COUNT) - 1);
  }
  frame[offset] = checksumBytes(frame.subarray(0, offset));
  return frame;
}

function buildSongChainFrame() {
  const frame = new Uint8Array(SONG_CHAIN_FRAME_BYTES);
  let offset = 0;
  frame.set(SONG_CHAIN_MAGIC, offset);
  offset += SONG_CHAIN_MAGIC.length;
  frame[offset++] = PATTERN_VERSION;
  frame[offset++] = clamp(state.song.length | 0, 1, SONG_CHAIN_SLOT_COUNT);
  for (let index = 0; index < SONG_CHAIN_SLOT_COUNT; index++) {
    frame[offset++] = clamp(state.song.slots[index] ?? 0, 0, PATTERN_COUNT - 1);
  }
  frame[offset] = checksumBytes(frame.subarray(0, offset));
  return frame;
}

function buildSettingsFrame() {
  const frame = new Uint8Array(SETTINGS_FRAME_BYTES);
  let offset = 0;
  frame.set(SETTINGS_MAGIC, offset);
  offset += SETTINGS_MAGIC.length;
  frame[offset++] = PATTERN_VERSION;
  frame[offset++] = clamp(state.settings.midiChannel | 0, 1, 16);
  frame[offset++] = normalizeClockResolution(state.settings.analogClockResolution);
  frame[offset++] = normalizeClockResolution(state.settings.midiClockResolution);
  frame[offset] = checksumBytes(frame.subarray(0, offset));
  return frame;
}

function matchesSerialFramePrefix(buffer, frameType) {
  const limit = Math.min(buffer.length, frameType.magic.length);
  for (let i = 0; i < limit; i++) {
    if (buffer[i] !== frameType.magic[i]) {
      return false;
    }
  }
  return true;
}

function matchesSerialFrameMagic(buffer, frameType) {
  if (buffer.length < frameType.magic.length) {
    return false;
  }
  for (let i = 0; i < frameType.magic.length; i++) {
    if (buffer[i] !== frameType.magic[i]) {
      return false;
    }
  }
  return true;
}

function trimToSerialFrameHeader(buffer) {
  while (buffer.length > 0 && !SERIAL_FRAME_TYPES.some((frameType) => matchesSerialFramePrefix(buffer, frameType))) {
    buffer.shift();
  }
}

function getBufferedSerialFrameType(buffer) {
  return SERIAL_FRAME_TYPES.find((frameType) => buffer.length >= frameType.length && matchesSerialFrameMagic(buffer, frameType));
}

function validatePatternFrame(frame) {
  if (!frame || frame.length !== PATTERN_FRAME_BYTES) {
    throw new Error("Unexpected pattern frame length.");
  }
  for (let i = 0; i < PATTERN_MAGIC.length; i++) {
    if (frame[i] !== PATTERN_MAGIC[i]) {
      throw new Error("Pattern frame header mismatch.");
    }
  }
  const version = frame[PATTERN_MAGIC.length];
  if (version !== PATTERN_VERSION) {
    throw new Error(`Unsupported pattern frame version ${version}.`);
  }
  const stepCount = frame[PATTERN_MAGIC.length + 2];
  const voiceCount = frame[PATTERN_MAGIC.length + 3];
  if (stepCount !== PATTERN_STEP_COUNT || voiceCount !== PATTERN_VOICE_COUNT) {
    throw new Error(`Unexpected pattern size ${voiceCount}x${stepCount}.`);
  }
  const checksum = frame[frame.length - 1];
  const expected = checksumBytes(frame.subarray(0, frame.length - 1));
  if (checksum !== expected) {
    throw new Error("Pattern frame checksum mismatch.");
  }
}

function applyPatternFrame(frame) {
  validatePatternFrame(frame);
  const slot = frame[PATTERN_MAGIC.length + 1];
  const maskOffset = PATTERN_MAGIC.length + 4;
  const nextSlot = clamp(slot, 0, PATTERN_COUNT - 1);
  const refreshStartedAt = patternRefreshStartedAt[nextSlot] || 0;
  if (refreshStartedAt && patternLocalEditAt[nextSlot] > refreshStartedAt) {
    patternRefreshStartedAt[nextSlot] = 0;
    return;
  }
  patternRefreshStartedAt[nextSlot] = 0;
  const patternSteps = state.pattern.patterns[nextSlot];
  for (let step = 0; step < PATTERN_STEP_COUNT; step++) {
    patternSteps[step] = frame[maskOffset + step] & ((1 << PATTERN_VOICE_COUNT) - 1);
  }
  applyingRemotePattern = true;
  state.pattern.slot = nextSlot;
  state.pattern.steps = patternSteps;
  if (!state.song.dirty && !state.song.loaded) {
    fillSongBuilderWithCurrentPattern();
  }
  renderPatternEditor();
  applyingRemotePattern = false;
}

function validateStepFrame(frame) {
  if (!frame || frame.length !== PATTERN_STEP_FRAME_BYTES) {
    throw new Error("Unexpected step frame length.");
  }
  for (let i = 0; i < PATTERN_STEP_MAGIC.length; i++) {
    if (frame[i] !== PATTERN_STEP_MAGIC[i]) {
      throw new Error("Step frame header mismatch.");
    }
  }
  const version = frame[PATTERN_STEP_MAGIC.length];
  if (version !== PATTERN_VERSION) {
    throw new Error(`Unsupported step frame version ${version}.`);
  }
  const slot = frame[PATTERN_STEP_MAGIC.length + 1];
  const step = frame[PATTERN_STEP_MAGIC.length + 2];
  if (slot >= PATTERN_COUNT || step >= PATTERN_STEP_COUNT) {
    throw new Error(`Unexpected step position ${slot}:${step}.`);
  }
  const checksum = frame[frame.length - 1];
  const expected = checksumBytes(frame.subarray(0, frame.length - 1));
  if (checksum !== expected) {
    throw new Error("Step frame checksum mismatch.");
  }
}

function applyStepFrame(frame) {
  validateStepFrame(frame);
  const slot = frame[PATTERN_STEP_MAGIC.length + 1];
  const step = frame[PATTERN_STEP_MAGIC.length + 2];
  if (slot !== state.pattern.slot) {
    return;
  }
  flashDeviceStep(step);
}

function validateSongChainFrame(frame) {
  if (!frame || frame.length !== SONG_CHAIN_FRAME_BYTES) {
    throw new Error("Unexpected song frame length.");
  }
  for (let i = 0; i < SONG_CHAIN_MAGIC.length; i++) {
    if (frame[i] !== SONG_CHAIN_MAGIC[i]) {
      throw new Error("Song frame header mismatch.");
    }
  }
  const version = frame[SONG_CHAIN_MAGIC.length];
  if (version !== PATTERN_VERSION) {
    throw new Error(`Unsupported song frame version ${version}.`);
  }
  const length = frame[SONG_CHAIN_MAGIC.length + 1];
  if (length < 1 || length > SONG_CHAIN_SLOT_COUNT) {
    throw new Error(`Unexpected song length ${length}.`);
  }
  const slotOffset = SONG_CHAIN_MAGIC.length + 2;
  for (let index = 0; index < SONG_CHAIN_SLOT_COUNT; index++) {
    if (frame[slotOffset + index] >= PATTERN_COUNT) {
      throw new Error(`Unexpected song slot ${frame[slotOffset + index]}.`);
    }
  }
  const checksum = frame[frame.length - 1];
  const expected = checksumBytes(frame.subarray(0, frame.length - 1));
  if (checksum !== expected) {
    throw new Error("Song frame checksum mismatch.");
  }
}

function applySongChainFrame(frame) {
  validateSongChainFrame(frame);
  if (songRefreshStartedAt && songLocalEditAt > songRefreshStartedAt) {
    songRefreshStartedAt = 0;
    return;
  }

  songRefreshStartedAt = 0;
  const slotOffset = SONG_CHAIN_MAGIC.length + 2;
  state.song.length = clamp(frame[SONG_CHAIN_MAGIC.length + 1], 1, SONG_CHAIN_SLOT_COUNT);
  for (let index = 0; index < SONG_CHAIN_SLOT_COUNT; index++) {
    state.song.slots[index] = clamp(frame[slotOffset + index], 0, PATTERN_COUNT - 1);
  }
  state.song.dirty = false;
  state.song.loaded = true;
  renderSongBuilder();
  updateControls();
}

function validateSettingsFrame(frame) {
  if (!frame || frame.length !== SETTINGS_FRAME_BYTES) {
    throw new Error("Unexpected settings frame length.");
  }
  for (let i = 0; i < SETTINGS_MAGIC.length; i++) {
    if (frame[i] !== SETTINGS_MAGIC[i]) {
      throw new Error("Settings frame header mismatch.");
    }
  }
  const version = frame[SETTINGS_MAGIC.length];
  if (version !== PATTERN_VERSION) {
    throw new Error(`Unsupported settings frame version ${version}.`);
  }
  const midiChannel = frame[SETTINGS_MAGIC.length + 1];
  const analogClockResolution = frame[SETTINGS_MAGIC.length + 2];
  const midiClockResolution = frame[SETTINGS_MAGIC.length + 3];
  if (midiChannel < 1 || midiChannel > 16) {
    throw new Error(`Unexpected MIDI channel ${midiChannel}.`);
  }
  if (analogClockResolution > CLOCK_RESOLUTION_STEP || midiClockResolution > CLOCK_RESOLUTION_STEP) {
    throw new Error("Unexpected clock resolution setting.");
  }
  const checksum = frame[frame.length - 1];
  const expected = checksumBytes(frame.subarray(0, frame.length - 1));
  if (checksum !== expected) {
    throw new Error("Settings frame checksum mismatch.");
  }
}

function applySettingsFrame(frame) {
  validateSettingsFrame(frame);
  if (settingsRefreshStartedAt && settingsLocalEditAt > settingsRefreshStartedAt) {
    settingsRefreshStartedAt = 0;
    return;
  }

  settingsRefreshStartedAt = 0;
  state.settings.midiChannel = clamp(frame[SETTINGS_MAGIC.length + 1], 1, 16);
  state.settings.analogClockResolution = normalizeClockResolution(frame[SETTINGS_MAGIC.length + 2]);
  state.settings.midiClockResolution = normalizeClockResolution(frame[SETTINGS_MAGIC.length + 3]);
  state.settings.loaded = true;
  renderSettingsEditor();
  updateControls();
}

function handleSerialInput(bytes) {
  for (const byte of bytes) {
    serialPatternBuffer.push(byte);
    trimToSerialFrameHeader(serialPatternBuffer);

    let frameType = getBufferedSerialFrameType(serialPatternBuffer);
    while (frameType) {
      const frame = Uint8Array.from(serialPatternBuffer.slice(0, frameType.length));
      try {
        if (frameType.type === "pattern") {
          applyPatternFrame(frame);
        } else if (frameType.type === "step") {
          applyStepFrame(frame);
        } else if (frameType.type === "song") {
          applySongChainFrame(frame);
        } else if (frameType.type === "settings") {
          applySettingsFrame(frame);
        }
        serialPatternBuffer.splice(0, frameType.length);
      } catch (error) {
        serialPatternBuffer.shift();
        trimToSerialFrameHeader(serialPatternBuffer);
      }
      frameType = getBufferedSerialFrameType(serialPatternBuffer);
    }
  }
}

function startSerialReader() {
  if (!state.port || !state.port.readable || serialReaderPromise) {
    return;
  }

  serialReadStopRequested = false;
  serialReaderPromise = (async () => {
    try {
      serialReader = state.port.readable.getReader();
      while (!serialReadStopRequested && state.port) {
        const { value, done } = await serialReader.read();
        if (done) {
          break;
        }
        if (value && value.length) {
          handleSerialInput(value);
        }
      }
    } catch (error) {
      if (!serialReadStopRequested) {
        log(`Serial read stopped: ${error.message}`, "error");
      }
    } finally {
      if (serialReader) {
        try {
          serialReader.releaseLock();
        } catch (error) {
          // The stream can already be closed when the device is unplugged.
        }
      }
      serialReader = null;
      serialReaderPromise = null;
      serialReadStopRequested = false;
    }
  })();
}

async function stopSerialReader() {
  serialReadStopRequested = true;
  if (serialReader) {
    try {
      await serialReader.cancel();
    } catch (error) {
      // Cancellation is best-effort; closing the port also releases the reader.
    }
  }
  if (serialReaderPromise) {
    await serialReaderPromise;
  }
}

function checksumBytes(bytes) {
  let checksum = 0;
  for (const byte of bytes) {
    checksum = (checksum + byte) & 0xff;
  }
  return checksum;
}

function isDeton8SerialPort(port) {
  if (!port || typeof port.getInfo !== "function") {
    return false;
  }
  const info = port.getInfo();
  return info.usbVendorId === DETON8_USB_VENDOR_ID && info.usbProductId === DETON8_USB_PRODUCT_ID;
}

function clearSerialReconnectTimer() {
  if (serialReconnectTimer) {
    clearTimeout(serialReconnectTimer);
    serialReconnectTimer = null;
  }
}

async function openSerialPort(port, { automatic = false, allowUnknown = false } = {}) {
  if (!port || state.port || state.portOpening || state.uploading) {
    return false;
  }
  const knownDeton8Port = isDeton8SerialPort(port);
  if (!knownDeton8Port && !allowUnknown) {
    if (!automatic) {
      log("Selected serial port does not match deton8 USB ID 16D0:0E6F.", "error");
    }
    return false;
  }

  clearSerialReconnectTimer();
  const wasReconnectPending = state.reconnectPending;
  state.portOpening = true;
  state.reconnectPending = false;
  updateControls();

  try {
    await stopSerialReader();
    await port.open({ baudRate: DETON8_SERIAL_BAUD_RATE });
    state.port = port;
    serialPatternBuffer.length = 0;
    startSerialReader();
    void requestDeviceEditorState();
    log(allowUnknown && !knownDeton8Port
      ? "Connected to manual serial port."
      : `${automatic ? "Auto-connected" : "Connected"} to deton8.`);
    return true;
  } catch (error) {
    if (!automatic) {
      log(`Could not open deton8 serial port: ${error.message}`, "error");
    } else if (!wasReconnectPending) {
      console.warn(`deton8 auto-connect failed: ${error.message}`);
    }
    return false;
  } finally {
    state.portOpening = false;
    updateControls();
  }
}

async function autoConnectToKnownSerialPort() {
  if (!canUseWebSerial() || state.port || state.portOpening || state.uploading) {
    return false;
  }

  let ports;
  try {
    ports = await navigator.serial.getPorts();
  } catch (error) {
    log(`Could not scan approved serial ports: ${error.message}`, "error");
    return false;
  }

  const deton8Port = ports.find(isDeton8SerialPort);
  if (!deton8Port) {
    return false;
  }
  return openSerialPort(deton8Port, { automatic: true });
}

function scheduleSerialReconnect(delay = SERIAL_RECONNECT_INITIAL_DELAY_MS) {
  if (!canUseWebSerial() || state.port || state.portOpening || serialReconnectTimer) {
    return;
  }

  state.reconnectPending = true;
  updateControls();
  serialReconnectTimer = setTimeout(async () => {
    serialReconnectTimer = null;
    const connected = await autoConnectToKnownSerialPort();
    if (!connected && !state.port) {
      scheduleSerialReconnect(Math.min(delay * 1.5, SERIAL_RECONNECT_MAX_DELAY_MS));
    }
  }, delay);
}

async function connectToSerial() {
  if (!("serial" in navigator)) {
    log("WebSerial is not supported in this browser.", "error");
    return;
  }
  if (!window.isSecureContext) {
    log("WebSerial only works over https:// or http://localhost. Launch the app from a secure origin.", "error");
    return;
  }

  try {
    clearSerialReconnectTimer();
    state.reconnectPending = false;
    const port = await navigator.serial.requestPort({ filters: DETON8_SERIAL_FILTERS });
    await openSerialPort(port, { automatic: false });
  } catch (error) {
    if (error.name === "NotFoundError") {
      log("Serial port chooser closed without selecting deton8. Use Manual serial if the device appears under another name.", "warn");
    } else {
      log(`Could not open serial port: ${error.message}`, "error");
    }
  } finally {
    updateControls();
  }
}

async function connectToManualSerial() {
  if (!("serial" in navigator)) {
    log("WebSerial is not supported in this browser.", "error");
    return;
  }
  if (!window.isSecureContext) {
    log("WebSerial only works over https:// or http://localhost. Launch the app from a secure origin.", "error");
    return;
  }

  try {
    clearSerialReconnectTimer();
    state.reconnectPending = false;
    const port = await navigator.serial.requestPort();
    await openSerialPort(port, { automatic: false, allowUnknown: true });
  } catch (error) {
    if (error.name === "NotFoundError") {
      log("Manual serial chooser closed without selecting a port.", "warn");
    } else {
      log(`Could not open manual serial port: ${error.message}`, "error");
    }
  } finally {
    updateControls();
  }
}

async function disconnectSerial() {
  clearSerialReconnectTimer();
  state.reconnectPending = false;
  if (!state.port) {
    updateControls();
    return;
  }

  const port = state.port;
  try {
    await stopSerialReader();
    await port.close();
    log("Serial port disconnected.");
  } catch (error) {
    log(`Error while closing serial port: ${error.message}`, "error");
  } finally {
    state.port = null;
    updateControls();
  }
}

function handleSerialConnect(event) {
  if (state.port || state.portOpening) {
    return;
  }
  if (!event.port) {
    void autoConnectToKnownSerialPort();
    return;
  }
  if (event.port && !isDeton8SerialPort(event.port)) {
    return;
  }
  void openSerialPort(event.port, { automatic: true });
}

function handleSerialDisconnect(event) {
  if (event.port === state.port) {
    log("deton8 unplugged. Waiting to reconnect.", "error");
    serialReadStopRequested = true;
    serialPatternBuffer.length = 0;
    state.port = null;
    state.uploading = false;
    state.patternTransfer = false;
    void stopSerialReader();
    updateControls();
    scheduleSerialReconnect();
  }
}

async function ensureAudioContext() {
  if (!audioCtx) {
    audioCtx = new AudioContext();
  }
  if (audioCtx.state === "suspended") {
    await audioCtx.resume();
  }
  return audioCtx;
}

function mixToMono(buffer) {
  const { numberOfChannels, length } = buffer;
  if (numberOfChannels === 1) {
    return Float32Array.from(buffer.getChannelData(0));
  }
  const mix = new Float32Array(length);
  for (let channel = 0; channel < numberOfChannels; channel++) {
    const channelData = buffer.getChannelData(channel);
    for (let i = 0; i < length; i++) {
      mix[i] += channelData[i];
    }
  }
  const inv = 1 / numberOfChannels;
  for (let i = 0; i < length; i++) {
    mix[i] *= inv;
  }
  return mix;
}

function float32ToUint8(samples) {
  const output = new Uint8Array(samples.length);
  for (let i = 0; i < samples.length; i++) {
    const clamped = Math.max(-1, Math.min(1, samples[i]));
    const quantized = Math.round(clamped * 127);
    output[i] = clampByte(quantized + 127);
  }
  return output;
}

function bytesToFloat32(bytes) {
  const floats = new Float32Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    floats[i] = (bytes[i] - 127) / 127;
  }
  return floats;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function encoded7BitLength(rawLength) {
  const groups = Math.floor(rawLength / 7);
  const remainder = rawLength % 7;
  return (groups * 8) + (remainder ? remainder + 1 : 0);
}

function encode7BitBytes(bytes) {
  const encoded = new Uint8Array(encoded7BitLength(bytes.length));
  let sourceOffset = 0;
  let targetOffset = 0;

  while (sourceOffset < bytes.length) {
    const msbOffset = targetOffset++;
    let msbs = 0;
    for (let bit = 0; bit < 7 && sourceOffset < bytes.length; bit++) {
      const value = bytes[sourceOffset++];
      if (value & 0x80) {
        msbs |= 1 << bit;
      }
      encoded[targetOffset++] = value & 0x7f;
    }
    encoded[msbOffset] = msbs;
  }

  return encoded;
}

function buildLegacyMidiKitFrame(command, body = []) {
  const bodyBytes = body instanceof Uint8Array ? body : Uint8Array.from(body);
  const payloadLength = 1 + LEGACY_MIDI_MAGIC.length + 1 + 1 + bodyBytes.length;
  const payload = new Uint8Array(payloadLength);
  let offset = 0;
  payload[offset++] = LEGACY_MIDI_VENDOR_ID;
  payload.set(LEGACY_MIDI_MAGIC, offset);
  offset += LEGACY_MIDI_MAGIC.length;
  payload[offset++] = LEGACY_MIDI_VERSION;
  payload[offset++] = command;
  payload.set(bodyBytes, offset);

  const frame = new Uint8Array(payload.length + 3);
  frame[0] = 0xf0;
  frame.set(payload, 1);
  frame[frame.length - 2] = checksumBytes(payload) & 0x7f;
  frame[frame.length - 1] = 0xf7;
  return frame;
}

function buildLegacyMidiDataFrame(page, chunk, rawBytes) {
  const encoded = encode7BitBytes(rawBytes);
  const body = new Uint8Array(3 + encoded.length);
  body[0] = page & 0x7f;
  body[1] = chunk & 0x7f;
  body[2] = rawBytes.length & 0x7f;
  body.set(encoded, 3);
  return buildLegacyMidiKitFrame(LEGACY_MIDI_DATA_COMMAND, body);
}

function buildLegacyMidiMarkerFrame(markers) {
  const encoded = encode7BitBytes(markers);
  const body = new Uint8Array(1 + encoded.length);
  body[0] = markers.length & 0x7f;
  body.set(encoded, 1);
  return buildLegacyMidiKitFrame(LEGACY_MIDI_MARKERS_COMMAND, body);
}

async function sendKitViaLegacyMidi() {
  if (state.uploading || state.patternTransfer || state.legacyMidi.sending) {
    return;
  }
  if (state.lastLength === 0) {
    log("No audio to send. Load a kit or add samples first.", "error");
    return;
  }

  const access = await ensureLegacyMidiAccess();
  if (!access) {
    return;
  }

  refreshLegacyMidiOutputs();
  const output = getSelectedLegacyMidiOutput();
  if (!output) {
    log("Choose a legacy MIDI output first.", "error");
    return;
  }

  state.legacyMidi.sending = true;
  setTransferProgress(0);
  updateControls();
  log(`Starting legacy MIDI send to ${output.name || "selected output"}...`);

  try {
    const payload = buildTransferPayload();
    const markers = buildMarkerPayload();
    let offset = 0;

    output.send(buildLegacyMidiKitFrame(LEGACY_MIDI_START_COMMAND));
    await sleep(LEGACY_MIDI_PAGE_DELAY_MS);

    for (let page = 0; page < PAGES_TO_SEND; page++) {
      for (let chunk = 0; chunk < LEGACY_MIDI_CHUNKS_PER_PAGE; chunk++) {
        const rawBytes = payload.subarray(offset, offset + LEGACY_MIDI_CHUNK_BYTES);
        output.send(buildLegacyMidiDataFrame(page, chunk, rawBytes));
        offset += LEGACY_MIDI_CHUNK_BYTES;
        await sleep(LEGACY_MIDI_CHUNK_DELAY_MS);
      }
      setTransferProgress(((page + 1) / PAGES_TO_SEND) * 100);
      log(`Sent legacy MIDI page ${page + 1} / ${PAGES_TO_SEND}.`);
      await sleep(LEGACY_MIDI_PAGE_DELAY_MS);
    }

    output.send(buildLegacyMidiMarkerFrame(markers));
    setTransferProgress(100);
    log("Legacy MIDI kit send completed.");
  } catch (error) {
    log(`Legacy MIDI send failed: ${error.message}`, "error");
  } finally {
    state.legacyMidi.sending = false;
    updateControls();
  }
}

async function uploadKit() {
  if (!state.port) {
    log("Connect to the deton8 first.", "error");
    return;
  }
  if (state.uploading || state.patternTransfer) {
    return;
  }
  if (state.lastLength === 0) {
    log("No audio to transfer. Load a kit or add samples first.", "error");
    return;
  }

  state.uploading = true;
  setTransferProgress(0);
  updateControls();
  log("Starting transfer…");

  let writer;
  let reader;

  try {
    await stopSerialReader();
    writer = state.port.writable.getWriter();
    reader = state.port.readable.getReader();

    await writer.write(Uint8Array.from([START_COMMAND]));

    const payload = buildTransferPayload();
    let offset = 0;

    for (let page = 0; page < PAGES_TO_SEND; page++) {
      await waitForReady(reader);
      const chunk = payload.subarray(offset, offset + PAGE_SIZE);
      await writer.write(chunk);
      offset += PAGE_SIZE;
      setTransferProgress(((page + 1) / PAGES_TO_SEND) * 100);
      log(`Transferred page ${page + 1} / ${PAGES_TO_SEND}.`);
    }

    const markers = buildMarkerPayload();
    await writer.write(markers);
    setTransferProgress(100);

    log("Transfer to deton8 completed successfully.");
  } catch (error) {
    log(`Transfer failed: ${error.message}`, "error");
  } finally {
    if (reader) {
      try {
        await reader.cancel();
      } catch (error) {
        // ignore cancellation errors
      }
      reader.releaseLock();
    }
    if (writer) {
      writer.releaseLock();
    }
    state.uploading = false;
    if (state.port) {
      startSerialReader();
    }
    updateControls();
  }
}

function buildTransferPayload() {
  const payload = new Uint8Array(TRANSFER_BYTES);
  let audioIndex = 0;
  let cursor = 0;
  for (let page = 0; page < PAGES_TO_SEND; page++) {
    for (let i = 0; i < 512; i++) {
      const hi = state.audioBuffer[audioIndex] ?? 127;
      const lo = state.audioBuffer[audioIndex + HALF_BUFFER] ?? 127;
      payload[cursor++] = hi;
      payload[cursor++] = lo;
      audioIndex += 2;
    }
  }
  return payload;
}

function buildMarkerPayload() {
  const buffer = new Uint8Array(MARKER_BYTES);
  let offset = 0;
  for (let i = 0; i < SLOT_COUNT; i++) {
    const value = state.markersIn[i] ?? 0;
    buffer[offset++] = (value >> 8) & 0xff;
    buffer[offset++] = value & 0xff;
  }
  for (let i = 0; i < SLOT_COUNT; i++) {
    const value = state.markersOut[i] ?? 0;
    buffer[offset++] = (value >> 8) & 0xff;
    buffer[offset++] = value & 0xff;
  }
  return buffer;
}

async function waitForReady(reader) {
  while (true) {
    const { value, done } = await reader.read();
    if (done) {
      throw new Error("Device closed the connection.");
    }
    if (!value) {
      continue;
    }
    for (const byte of value) {
      if (byte === 1) {
        return;
      }
    }
    log(`Device sent ${value.length} byte(s) while waiting for ready signal.`);
  }
}

function updateSlotCount() {
  const count = state.samples.filter(Boolean).length;
  slotCountEl.textContent = `${count} / ${SLOT_COUNT} loaded`;
}

function setTransferProgress(percent) {
  const value = clamp(Number.isFinite(percent) ? percent : 0, 0, 100);
  if (transferProgressBar) {
    transferProgressBar.style.width = `${value}%`;
    const progressRoot = transferProgressBar.closest(".progress-bar");
    if (progressRoot) {
      progressRoot.setAttribute("aria-valuenow", String(Math.round(value)));
    }
  }
}

function updateControls() {
  const serialAvailable = canUseWebSerial();
  const midiAvailable = canUseWebMidi();
  const midiBusy = state.legacyMidi.opening || state.legacyMidi.sending;
  const busy = state.uploading || state.portOpening || midiBusy;
  const uploadDisabled = !state.port || state.lastLength === 0 || state.uploading || state.patternTransfer || midiBusy;
  const selectedLegacyMidiOutput = !!state.legacyMidi.outputId;
  const legacyMidiPanelExpanded = !!state.legacyMidi.expanded;
  const legacyMidiSendDisabled = !legacyMidiPanelExpanded || !midiAvailable || state.lastLength === 0 || state.uploading || state.patternTransfer || state.legacyMidi.sending || state.legacyMidi.opening || !selectedLegacyMidiOutput;
  let transferStatus = "Ready to transfer to deton8.";
  if (!serialAvailable && !midiAvailable) {
    transferStatus = "Use Chrome or Edge over https:// or localhost.";
  } else if (state.portOpening) {
    transferStatus = "Connecting to deton8...";
  } else if (state.uploading) {
    transferStatus = "Transfer in progress...";
  } else if (state.legacyMidi.opening) {
    transferStatus = "Opening MIDI outputs...";
  } else if (state.legacyMidi.sending) {
    transferStatus = "Legacy MIDI send in progress...";
  } else if (state.patternTransfer) {
    transferStatus = "Editor sync in progress...";
  } else if (state.reconnectPending) {
    transferStatus = "Waiting for deton8 to reconnect...";
  } else if (!state.port && selectedLegacyMidiOutput && state.lastLength > 0) {
    transferStatus = "Ready for legacy MIDI send.";
  } else if (!state.port && serialAvailable) {
    transferStatus = "Click Connect, or Manual serial if deton8 is not listed.";
  } else if (!state.port && midiAvailable && !selectedLegacyMidiOutput) {
    transferStatus = "Choose a MIDI output for legacy transfer.";
  } else if (state.lastLength === 0) {
    transferStatus = "Load audio into at least one slot.";
  }

  connectBtn.disabled = !!state.port || !serialAvailable || busy;
  connectBtn.hidden = !!state.port;
  connectBtn.textContent = state.port ? "Connected" : state.portOpening ? "Connecting..." : "Connect";
  connectBtn.title = serialAvailable
    ? state.port ? "deton8 serial port connected." : "Choose the deton8 USB serial port."
    : "WebSerial requires Chrome or Edge over https:// or localhost.";
  if (manualConnectBtn) {
    manualConnectBtn.disabled = !!state.port || !serialAvailable || busy;
    manualConnectBtn.hidden = !!state.port;
    manualConnectBtn.title = serialAvailable
      ? "Choose from all visible serial ports."
      : "WebSerial requires Chrome or Edge over https:// or localhost.";
  }
  uploadBtn.disabled = uploadDisabled;
  uploadBtn.title = transferStatus;
  if (transferStatusEl) {
    transferStatusEl.textContent = transferStatus;
    transferStatusEl.classList.toggle("transfer-status--ready", !uploadDisabled);
  }
  if (saveKitBtn) {
    saveKitBtn.disabled = state.lastLength === 0 || busy;
  }
  if (legacyMidiContainer) {
    legacyMidiContainer.classList.toggle("is-open", legacyMidiPanelExpanded);
  }
  if (legacyMidiToggleBtn) {
    legacyMidiToggleBtn.disabled = !midiAvailable || state.uploading || state.portOpening || state.legacyMidi.sending;
    legacyMidiToggleBtn.setAttribute("aria-expanded", legacyMidiPanelExpanded ? "true" : "false");
    legacyMidiToggleBtn.title = midiAvailable
      ? "Show MIDI output options for legacy kit transfer."
      : "Web MIDI requires Chrome or Edge over https:// or localhost.";
  }
  if (legacyMidiPanel) {
    legacyMidiPanel.setAttribute("aria-hidden", legacyMidiPanelExpanded ? "false" : "true");
  }
  if (legacyMidiOutputSelect) {
    legacyMidiOutputSelect.disabled = !legacyMidiPanelExpanded || !midiAvailable || state.uploading || state.portOpening || state.legacyMidi.sending;
    legacyMidiOutputSelect.title = midiAvailable
      ? "Choose a MIDI output for legacy kit transfer."
      : "Web MIDI requires Chrome or Edge over https:// or localhost.";
  }
  if (legacyMidiSendBtn) {
    legacyMidiSendBtn.disabled = legacyMidiSendDisabled;
    legacyMidiSendBtn.title = legacyMidiSendDisabled
      ? selectedLegacyMidiOutput ? transferStatus : "Choose a MIDI output first."
      : "Send kit over legacy MIDI SysEx.";
  }
  if (clearPatternBtn) {
    clearPatternBtn.disabled = busy;
  }
  if (randomPatternBtn) {
    randomPatternBtn.disabled = busy;
  }
  if (copyPatternBtn) {
    copyPatternBtn.disabled = busy;
  }
  if (pastePatternBtn) {
    const hasClipboard = !!state.pattern.clipboard;
    pastePatternBtn.disabled = busy || !hasClipboard;
    pastePatternBtn.classList.toggle("accent", hasClipboard);
    pastePatternBtn.classList.toggle("ghost", !hasClipboard);
    pastePatternBtn.textContent = hasClipboard && Number.isInteger(state.pattern.clipboardSlot)
      ? `Paste ${formatPatternSlot(state.pattern.clipboardSlot)}`
      : "Paste";
  }
  if (savePatternBtn) {
    savePatternBtn.disabled = busy || state.patternTransfer || !state.port;
  }
  if (patternSlotSelect) {
    patternSlotSelect.disabled = busy || state.patternTransfer;
  }
  if (songLengthSelect) {
    songLengthSelect.disabled = busy || state.patternTransfer;
  }
  songSlotSelects.forEach((select, index) => {
    select.disabled = busy || state.patternTransfer || index >= state.song.length;
  });
  const settingsDisabled = busy || state.patternTransfer || !state.port;
  if (analogClockSelect) {
    analogClockSelect.disabled = settingsDisabled;
  }
  if (midiClockSelect) {
    midiClockSelect.disabled = settingsDisabled;
  }
  if (midiChannelSelect) {
    midiChannelSelect.disabled = settingsDisabled;
  }
}

function log(message, level = "info") {
  const text = `[${new Date().toLocaleTimeString()}] ${message}`;
  if (level === "error") {
    console.error(text);
  } else if (level === "warn") {
    console.warn(text);
  } else {
    console.log(text);
  }
}

function getExtension(name) {
  const index = name.lastIndexOf(".");
  if (index === -1) {
    return "";
  }
  return name.slice(index + 1).toLowerCase();
}

function findFirstEmptySlot() {
  return state.samples.findIndex((sample) => !sample);
}

function clampByte(value) {
  return Math.max(0, Math.min(255, value & 0xff));
}

function clampMarker(value) {
  const int = value | 0;
  if (int < 0) {
    return 0;
  }
  if (int > 0xffff) {
    return 0xffff;
  }
  return int;
}

function formatDuration(seconds) {
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return "—";
  }
  if (seconds < 1) {
    return `${Math.round(seconds * 1000)} ms`;
  }
  if (seconds < 10) {
    return `${seconds.toFixed(2)} s`;
  }
  return `${seconds.toFixed(1)} s`;
}

function formatNumber(value) {
  return value.toLocaleString();
}

function truncate(value, limit) {
  if (value.length <= limit) {
    return value;
  }
  return `${value.slice(0, limit - 1)}…`;
}

function redrawAllWaveforms() {
  slotUI.forEach((ui, index) => {
    const sample = state.samples[index];
    const selection = sample ? getSampleSelection(sample) : null;
    drawWaveform(ui.waveCanvas, sample ? sample.floats : null, selection);
  });
}

function drawWaveform(canvas, floats, selection) {
  if (!canvas) {
    return;
  }

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return;
  }

  const rect = canvas.getBoundingClientRect();
  const widthCss = Math.max(1, Math.floor(rect.width || canvas.width || 240));
  const heightCss = Math.max(32, Math.floor(rect.height || canvas.height || 64));
  const dpr = window.devicePixelRatio || 1;

  canvas.width = Math.max(1, Math.round(widthCss * dpr));
  canvas.height = Math.max(1, Math.round(heightCss * dpr));

  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.scale(dpr, dpr);
  ctx.clearRect(0, 0, widthCss, heightCss);

  ctx.fillStyle = "rgba(10, 12, 18, 0.96)";
  ctx.fillRect(0, 0, widthCss, heightCss);

  ctx.fillStyle = "rgba(0, 0, 0, 0.3)";
  ctx.fillRect(0, 0, widthCss, heightCss);

  const hasData = Array.isArray(floats) ? floats.length > 0 : !!(floats && floats.length);
  const dataLength = hasData ? floats.length : 0;

  let selectionStartRatio = 0;
  let selectionEndRatio = 1;
  if (hasData && selection && selection.end > selection.start) {
    selectionStartRatio = selection.start / dataLength;
    selectionEndRatio = selection.end / dataLength;
  }

  const selStartX = Math.floor(selectionStartRatio * widthCss);
  const selEndX = hasData
    ? Math.max(selStartX + 1, Math.ceil(selectionEndRatio * widthCss))
    : widthCss;
  ctx.fillStyle = "rgba(255, 255, 255, 0.14)";
  ctx.fillRect(selStartX, 0, selEndX - selStartX, heightCss);

  const mid = heightCss / 2;
  ctx.strokeStyle = "rgba(255, 255, 255, 0.22)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(0, mid);
  ctx.lineTo(widthCss, mid);
  ctx.stroke();

  if (!hasData) {
    return;
  }

  const amplitude = heightCss * 0.45;
  const step = dataLength / widthCss;

  ctx.strokeStyle = "rgba(255, 255, 255, 0.92)";
  ctx.lineWidth = 1;
  ctx.beginPath();

  for (let x = 0; x < widthCss; x++) {
    const start = Math.floor(x * step);
    let end = Math.floor((x + 1) * step);
    if (end <= start) {
      end = start + 1;
    }
    if (start >= dataLength) {
      break;
    }
    if (end > dataLength) {
      end = dataLength;
    }

    let min = 1;
    let max = -1;
    for (let i = start; i < end; i++) {
      const sample = floats[i];
      if (sample < min) {
        min = sample;
      }
      if (sample > max) {
        max = sample;
      }
    }

    const yHigh = mid - max * amplitude;
    const yLow = mid - min * amplitude;
    ctx.moveTo(x, yHigh);
    ctx.lineTo(x, yLow);
  }

  ctx.stroke();
}

window.addEventListener("beforeunload", () => {
  if (state.port && state.port.close) {
    state.port.close().catch(() => {});
  }
});
